import { SEOHead } from '@/components/layout/SEOHead'
import { ArticleCard } from '@/components/blog/ArticleCard'
import { graph, blog, organization, breadcrumbList } from '@/lib/jsonLd'
import { articles } from './articles'

/**
 * Blog index Schema.org graph:
 * - Blog (lists all articles as embedded BlogPosting nodes — full site map in one fetch)
 * - Organization (publisher identity, referenced by @id from Blog and BlogPostings)
 * - BreadcrumbList (Strona główna → Blog)
 *
 * Articles are sorted newest-first to bias AI summaries toward recent content.
 */
const SORTED_ARTICLES = [...articles].sort((a, b) => b.publishedAt.localeCompare(a.publishedAt))

const BLOG_LIST_JSONLD = graph(
  blog(SORTED_ARTICLES),
  organization(),
  breadcrumbList([
    { name: 'Strona główna', url: '/' },
    { name: 'Blog', url: '/blog' },
  ]),
)

export default function BlogListPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <SEOHead
        title="Blog | RatyGo"
        description="Artykuły o kredytach hipotecznych w Polsce. Raty równe vs malejące, nadpłaty, WIBOR, zdolność kredytowa i więcej."
        slug="/blog"
        keywords={['blog kredyt hipoteczny', 'porady kredytowe', 'raty równe malejące', 'WIBOR']}
        jsonLd={BLOG_LIST_JSONLD}
      />

      <header className="mb-8">
        <h1 className="text-3xl sm:text-4xl font-bold text-foreground mb-2">Blog</h1>
        <p className="text-muted-foreground">
          Praktyczne porady o kredytach hipotecznych w Polsce
        </p>
      </header>

      <div className="grid gap-6 sm:grid-cols-2">
        {SORTED_ARTICLES.map((article) => (
          <ArticleCard key={article.slug} article={article} />
        ))}
      </div>
    </div>
  )
}
